/**
 * Theme function for a message.
 *
 * @param {object} message
 *   The message object.
 * @param {string} message.text
 *   The message text.
 * @param {object} options
 *   The message context.
 * @param {string} options.type
 *   The message type.
 * @param {string} options.id
 *   ID of the message, for reference.
 *
 * @return {HTMLElement}
 *   A DOM Node.
 */
((Drupal) => {
  Drupal.theme.message = ({ text }, { type, id }) => {
    const messagesTypes = Drupal.Message.getMessageTypeLabels();
    const messageWrapper = document.createElement('div');
    var subType = 'info';

    if(type == 'status'){
      subType = 'success';
    }else if(type == 'eror') {
      subType = 'danger';
    }else if(type == 'warning') {
      subType = 'warning';
    }

    messageWrapper.setAttribute('class', `messages messages--${type} alert alert-${subType}`);
    messageWrapper.setAttribute(
        'role',
        type === 'error' || type === 'warning' ? 'alert' : 'status',
    );
    messageWrapper.setAttribute('data-drupal-message-id', id);
    messageWrapper.setAttribute('data-drupal-message-type', type);

    messageWrapper.setAttribute('aria-label', messagesTypes[type]);

    messageWrapper.innerHTML = `${text}`;

    return messageWrapper;
  };
})(Drupal);